var exports = {
  "o": "AgoTimestampLink__IcQHBK",
  "K": "timestampText__tn8r1u",
};

module.exports = exports;
